import { InitialCard } from '@components';
import { TickWithLabel } from './credit-report';
import cls from './credit-report.module.css';
import { CreditFileStatusTypes } from '@network';

interface CreditReportUserProps {
  isClientDocsValid: boolean;
  isClientProgressValid: boolean;
  hasClientGuarantor: boolean;
  isSurveyCompleted: boolean;
  isReportsCompleted: boolean;
  profileMissingFields: string[];
  isGuarantorsRequired?: boolean;
  isFileScreeningDocsReady: boolean;
}

export const CreditReportUser = ({
  isClientDocsValid, isClientProgressValid, hasClientGuarantor, isSurveyCompleted,
  isReportsCompleted, isGuarantorsRequired, profileMissingFields, isFileScreeningDocsReady,
}: CreditReportUserProps) => {
  return (
    <InitialCard
      left="Verification"
      boxClass={cls.verificationUser}
      contentClass={cls.userVerification}
    >
      <TickWithLabel
        label="Client"
        isValid={isClientProgressValid}
        tooltip={!isClientProgressValid ? (
          <div>
            <div>Please check the identity data of the customer.</div>
            {profileMissingFields?.length > 0 && (
              <div className={cls.profileMissingFields}>
                Empty fields:
                <ul className={cls.profileMissingFieldsList}>
                  {profileMissingFields.map(field => <li key={field}>{field}</li>)}
                </ul>
              </div>
            )}
          </div>
        ) : undefined}
      />
      <TickWithLabel label="Guarantor" isValid={hasClientGuarantor || !!isGuarantorsRequired} />
      <TickWithLabel label="Survey key questions" isValid={isSurveyCompleted} />
      {/*<TickWithLabel label="Reports Uploaded" isValid={isReportsCompleted} />*/}
      <TickWithLabel
        label="File Screening - Docs Ready"
        isValid={isFileScreeningDocsReady}
        tooltip={!isFileScreeningDocsReady ? 'Please check the credit File Status in admin platform.' : undefined}
      />
    </InitialCard>
  );
};
